import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
import ScalarSidebarIndent_vue_vue_type_script_setup_true_lang_default from "./ScalarSidebarIndent.vue.script.js";
/* empty css                                  */
//#region src/components/ScalarSidebar/ScalarSidebarIndent.vue
var ScalarSidebarIndent_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ScalarSidebarIndent_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-3e080c68"]]);
//#endregion
export { ScalarSidebarIndent_default as default };

//# sourceMappingURL=ScalarSidebarIndent.vue.js.map